export default async () => {
  return await Promise.resolve({
    loading: 'Chargement...',
    prev: 'Précédent',
    next: 'Suivant',
    hours: 'heure | heure | heures',
    minutes: 'minute | minute | minutes',
    seconds: 'seconde | seconde | secondes',
    the: 'Le',
    and: 'et',
    copyright: '{year} © Asphalte. Tous droits réservés.',
    b_corp_certified: 'Entreprise certifiée B Corp',
    color: 'Couleur :',
    hovered_color: 'Couleur survolée :',
    preco_of_the_week: 'Cette semaine uniquement !',
    next_thuesday: 'Rendez-vous mardi à 10h.',
    lauch_day: 'Rendez-vous {day} à 10h.',
    seo: {
      defaultTitle: 'Asphalte - Des bonnes fringues. Point.',
      defaultDesc:
        'On est une marque de vêtements pour les personnes qui veulent du style et de la qualité dans une pièce sans avoir à craquer le PEL tous les mois.',
    },
    context: {
      h: 'Homme',
      f: 'Femme',
    },
    action: {
      see: 'Voir le produit',
      add: 'Ajouter',
      added: 'Ajouté',
      edit: 'Modifier',
      delete: 'Supprimer',
      buy: 'Acheter',
      copy: 'Copier',
      share: 'Partager',
      preorder: 'Précommander',
      'add-to-cart': 'Ajouter au panier',
      subscribe: 'Je crée une alerte',
      unsubscribe: "Je désactive l'alerte",
      checkout: 'Passer la commande',
      reduce: 'Réduire',
      open: 'Ouvrir',
      open_filters: 'Accéder aux filtres',
      filter: 'Filtrer les produits',
      'continue-shopping': 'Continuer mes achats',
      show_eshop: 'Montrez moi toutes les précommandes',
      close: 'Fermer',
      cancel: 'Annuler',
      cancel_product: 'Annuler le produit',
      seePassword: 'Voir le mot de passe',
      hidePassword: 'Cacher le mot de passe',
      newsletterSubscribe: 'Je rejoins l’aventure',
      readMore: 'Voir plus',
      showAllPictures: 'Afficher toutes les photos',
      subscribe_to_list: 'Je signe',
      follow_order: 'Consulter le suivi',
      logout: 'Déconnectez moi !',
      return: 'Renvoyer un article',
      add_address: 'Ajouter une adresse',
      edit_address: 'Modifier une adresse',
      set_as_default: 'Adresse par défaut',
      save: 'Enregistrer',
      update_password: 'Mettre à jour le mot de passe',
      show_care_guide: 'Voir le guide d’entretien',
      prev: 'Précédent',
      next: 'Suivant',
      choose: 'Choisir',
    },
    success: {
      update_password: 'Mon mot de passe a bien été mis à jour',
      save: 'Mes informations ont bien été enregistrées',
      redirect: 'Redirection en cours...',
    },
    link: {
      menu: 'Menu',
      cart: 'Panier',
      infos: 'Infos',
      news: 'Actualités',
      'sign-in': 'Me connecter',
      account: 'Mon compte',
    },
    alert: {
      title: 'Mon expérience client',
      desc: `
        <p>Dans cette rubrique, vous retrouverez les produits Asphalte que vous attendez de pied ferme.</p>
        <p>S’ils apparaissent ici, c’est que vous vous êtes inscrit à l’alerte pour qu’on vous prévienne le jour du lancement, et vous pouvez compter sur nous.</p>
        <p>Si vous ne voyez rien à l’horizon, c’est surement qu’aucune pièce ne vous a tapé dans l’œil pour l’instant. Ça arrive, on ne le prend pas mal !</p>
        <p>Au cas où vous pensiez avoir loupé un épisode, on se fait une petite repasse sur les prochains lancements.</p>
        `,
      action: 'Qu’est-ce qu’on a au programme ?',
      none: "Aucun produit en ligne de mire pour l'instant.",
      tooltip: {
        create: 'Créer une alerte',
        remove: "Désactiver l'alerte",
        love: 'Créer une alerte',
        unlove: "Désactiver l'alerte",
      },
    },
    article: {
      publicated_at: 'Publié le {date}.',
      next: 'Lire la suite',
    },
    stock: {
      title: 'Vente de stock',
      punchline: 'Livraison ultra rapide.',
      teasing_action: 'Montrez-moi ça',

      alert: {
        1: 'Premier arrivé, premier servi.',
        2: 'Inscrivez-vous ici pour avoir accès à la vente de stock une heure avant tout le monde.',
        highlight_title: 'Début de la vente de stock le {date}',
        receive_alert:
          'Pour qu’on vous tienne au courant quand la vente de stock sera ouverte, inscrivez-vous ici :',
        activated:
          'Vous êtes bien inscrit pour la vente de stock du {date} et recevrez un mail sur <strong>{email}</strong> lorsqu’elle sera dispo.',
        deactivated:
          'Vous êtes bien désinscrit pour la vente de stock du {date}',
      },
    },
    card: {
      product: {
        agenda: {
          status: 'De retour un jour',
          alert: {
            1: 'Premier à précommander, premier livré.',
            2: 'Inscrivez-vous ici pour avoir accès à la préco une heure avant tout le monde.',
          },
        },
        precommande: {
          status: 'Lancement en précommande',
        },
        stock: {
          status: 'Remise en stock',
        },
        'number-of-colors': '{number} couleurs disponibles',
        'number-of-colors-soon':
          '1 couleur à l’affiche | {number} couleurs à l’affiche',
        'number-of-colors-small': '{number} couleurs',
        'nb-preco':
          'Déjà <strong>{number}</strong> précommande | Déjà <strong>{number}</strong> précommande | Déjà <strong>{number}</strong> précommandes',
      },
    },
    cart: {
      title: 'Mon panier',
      empty: 'Votre panier est vide.',
      'sub-total': 'Sous-total',
      'shipping-calculated-later':
        'Frais de port et remises calculés à la caisse',
      'terms-agree': "Je suis d'accord avec les",
      'terms-agree-error': 'Vous devez accepter les conditions',
      delivery: 'Livraison gratuite à partir de {price}€ d’achat',
      free_delivery_left:
        'Plus que <strong class="text-color-secondary">{price}€</strong> pour en profiter',
      delivery_free: 'On espère que vous vous êtes fait plaisir !',
      delivery_free_sub: 'La livraison, c’est pour nous.',
      upsell: {
        title: {
          empty: 'Découvrez notre sélection',
          default: 'Et avec ceci ?',
          link: 'Produit complémentaire',
          'Les éternels': 'Et avec ceci ?',
          Cluster: 'Produit complémentaires',
        },
        default: 'Aussi en préco',
        link: 'Pour votre costume',
        'Les éternels': 'Nos éternels',
        Cluster: 'Livré en même temps',
        info: 'Disponible en précommande | Disponible en {number} coloris',
        action: 'Montrez-moi ça',
        h: {
          default: 'Pour lui / Aussi en préco',
          'Les éternels': 'Pour lui / Nos éternels',
        },
        f: {
          default: 'Pour elle',
          'Les éternels': 'Pour elle / Nos éternels',
        },
      },
      multipass: {
        title: 'Le Multipass',
        explain: 'Frais de port offerts sur tous vos achats',
        price: '{price} € / AN',
        no_obligation: 'Sans engagement',
        cta: 'Ajouter',
      },
      payments: 'Paiements acceptés',
    },
    cookie: {
      text: "En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies.",
      link: 'En savoir plus',
    },
    label: {
      color: 'Couleur :',
      size: 'Taille :',
      size_only: 'Taille',
      jacket: 'Taille Veste :',
      pant: 'Taille Pantalon :',
      amount: 'Montant :',
      quantity: 'Quantité :',
    },
    locale: {
      'de-DE': 'Deutsch',
      'en-US': 'English',
      'fr-FR': 'Français',
      small: {
        'de-DE': 'DE',
        'en-US': 'EN',
        'fr-FR': 'FR',
      },
    },
    countdown: {
      days: ' jour | jours',
      hours: 'heure | heures',
      minutes: 'minute | minutes',
      seconds: 'seconde | secondes',
      abbr: {
        days: 'J-{days}',
        hours: 'H-{hours}',
      },
    },
    faq: {
      title: 'FAQ',
      line1: {
        title: 'Comment dépenser sa cagnotte ?',
        content:
          "Il vous suffit de copier votre code cagnotte et de l'appliquer à votre panier lors de votre commande sur notre site.",
      },
      line2: {
        title: 'Quel article je peux acheter avec ce code ?',
        content:
          'Ce code fonctionne sur tout le site, pour un produit en précommande ou en stock.',
      },
      line3: {
        title:
          'Que se passe-t-il si le solde de ma cagnotte est supérieur à mon achat ?',
        content:
          'Pas de souci, on a pensé à tout ! On calcule le nouveau solde de votre cagnotte. Exemple : si vous avez 100€ sur votre cagnotte et que vous achetez un produit à 79€, votre nouveau solde disponible sera de 21€.',
      },
      line4: {
        title: 'Est-il possible d’utiliser le même code plusieurs fois ?',
        content:
          'Oui, vous n’avez qu’un code cagnotte que vous pourrez entrer à chaque commande, du moment que vous avez de l’argent sur le PEL bien sûr. La maison ne fait pas crédit.',
      },
      line5: {
        title: 'Est-il possible de donner ce code à quelqu’un d’autre ?',
        content:
          "Non, votre code cagnotte est lié directement à votre compte client. Donc si vous voulez faire croquer votre code à quelqu'un d'autre, il faut lui donner accès à votre compte client.",
      },
    },
    header: {
      menu: {
        eshop: 'E-shop',
      },
    },
    footer: {
      cgv: 'CGV & Données',
      cookie: 'Cookies',
      newsletter: {
        man: 'Homme',
        woman: 'Femme',
        subscribe: "C'est bon, c'est validé !",
        error: 'Oh non... Il y a eu une erreur.',
      },
      payments: {
        info: "Indication des moyens de paiements proposés pour l'achat. Ils dépendront cependant de votre adresse de livraison finale.",
      },
    },
    create_alert: {
      email: { placeholder: 'À vos mails, prêts, partez' },
      subscribe: 'Prévenez-moi',
    },
    product: {
      in_preco: 'En préco',
      in_stock: 'En stock',
      'available-from': 'Disponible à partir du {weekday} {month-day}',
      'receive-alert-preorder':
        'Pour qu’on vous tienne au courant quand le produit sera dispo en précommande, inscrivez-vous ici :',
      'receive-alert-stock':
        'Pour qu’on vous tienne au courant quand le produit sera dispo en stock, inscrivez-vous ici :',
      'color-not-available': 'Désolé, on est au bout du rouleau.',
      'size-not-available': 'Cette taille n’est plus dispo.',
      'soldout-saisonnier':
        'Toute la matière commandée pour cette couleur a été précommandée. Mais pas de panique, elle reviendra. Inscrivez-vous juste en dessous et dès que ce produit reviendra en précommande, vous serez le premier informé.',
      'back-one-day': 'De retour un jour',
      price_range: 'De {min} € à {max} €',
      available_sizes: 'Tailles disponibles :',
      tag: {
        soon_preco: 'Top départ dans',
        last_before_end: 'Fin de la préco dans',
        last_chance: 'Dernière chance',
        new_color: 'Nouvelle couleur',
        leaving_soon: 'Sur le départ',
      },
      soldout:
        'Toute la matière commandée pour cette couleur a été précommandée. Mais pas de panique, elle reviendra. Inscrivez-vous juste en dessous et dès que ce produit reviendra en précommande, vous serez le premier informé.',
      soldout_stock:
        'Le stock pour cette couleur est épuisé. Inscrivez-vous juste en dessous et dès que cette couleur reviendra en stock, on vous enverra un petit mail.',
      almost_sold_out:
        '<strong>Dernière pièce disponible</strong> | Plus que <strong>{number} pièces disponibles</strong>',
      sold: 'Déjà <strong>{sold}</strong> précommande| Déjà <strong>{sold}</strong> précommandes',
      alert: {
        activated:
          'Vous êtes bien inscrit pour {produit} et recevrez un mail sur <strong>{email}</strong> lorsqu’il sera à nouveau dispo.',
        deactivated: 'Vous êtes bien désinscrit pour {produit}',
        'unsubscribe-loading': 'Désinscription en cours',
        love: '{produit} est/sont désormais sur votre tableau de chasse. Comptez sur nous pour vous envoyer un mail dès qu’il/elle/ils/elles sera/seront dispo.',
        unlove:
          '{produit} a/ont été retiré/retirés/retirées de vos favoris. Vous vous êtes aimés, n’en parlons plus, et la vie continue.',
        error:
          "Il y a eu une erreur lors de l'inscription. Si le problème persiste, merci de contacter le service client.",
        highlight_title: '{name} : {date}',
        modal: {
          title: 'L’alerte est activée !',
          NOT_FOUND: {
            subtitle: 'Créez un compte pour gérer vos alertes.',
            explanations:
              'On nous dit dans l’oreillette que vous n’avez pas de compte. Une fois connecté, vous n’aurez plus à rentrer votre mail pour chaque inscription et vous pourrez gérer toutes vos alertes produit sur une même page.',
            where:
              'C’est pratique et vous gagnez surtout beaucoup de temps. Ça ne prend que quelques minutes et si ça vous intéresse, c’est par là :',
            action: "Je m'inscris",
          },
          ENABLED: {
            subtitle: 'Connectez-vous pour gérer vos alertes.',
            explanations:
              'Ça veut dire que dès que cette pièce sera à nouveau dispo en préco ou en stock, vous en serez le premier informé directement dans votre boîte mail.',
            where:
              'Si vous avez changé d’avis, pas de souci. Vous pouvez gérer vos alertes directement dans votre espace client.',
            action: 'Je me connecte',
          },
          DISABLED: {
            subtitle: 'Activez votre compte pour gérer vos alertes.',
            explanations:
              "On nous dit dans l’oreillette que vous n'avez pas encore activé votre compte. Une fois connecté, vous n’aurez plus à rentrer votre mail pour chaque inscription et vous pourrez gérer toutes vos alertes produit sur une même page.",
            where:
              'C’est pratique et vous gagnez surtout beaucoup de temps. Ça ne prend que quelques minutes et si ça vous intéresse, c’est par là :',
            action: 'J’active mon compte',
          },
          unsubscribe: {
            title: "L'alerte est désactivée.",
            NOT_FOUND: {
              explanations:
                'On nous dit dans l’oreillette que vous n’avez pas de compte. Une fois connecté, vous n’aurez plus à rentrer votre mail pour chaque inscription et vous pourrez gérer toutes vos alertes produit sur une même page.',
              where:
                'C’est pratique et vous gagnez surtout beaucoup de temps. Ça ne prend que quelques minutes et si ça vous intéresse, c’est par là :',
            },
            ENABLED: {
              explanations:
                'Vous ne recevrez plus d’alerte à propos de ce produit.',
              where:
                'Si vous changez finalement d’avis, Il suffit de vous réinscrire le produit en question, depuis notre page bientôt disponible.',
            },
            DISABLED: {
              explanations:
                "On nous dit dans l’oreillette que vous n'avez pas encore activé votre compte. Une fois connecté, vous n’aurez plus à rentrer votre mail pour chaque inscription et vous pourrez gérer toutes vos alertes produit sur une même page.",
              where:
                'C’est pratique et vous gagnez surtout beaucoup de temps. Ça ne prend que quelques minutes et si ça vous intéresse, c’est par là :',
            },
          },
        },
      },
      nav: {
        product: 'Produit',
        videoBlock: 'Vidéo',
        issueBlock: 'Vos problèmes',
        user_generated_content: 'Vos inspirations',
        simpleContentBlock: 'Description',
        morphoBlock: 'Morphologie',
        tracabiliteBlock: 'Traçabilité',
        impactBlock: 'Impact environnemental',
        avisClientBlock: 'Avis clients',
        assuranceBlock: 'Nos garanties',
        other: 'Autres',
        action: {
          precommande: 'Précommander',
          stock: 'Acheter',
          agenda: 'Créer une alerte',
        },
      },
      material: {
        title: 'Matière :',
        label: '{label} :',
        popup:
          '<p class="d-flex align-center text-base-mobile mb-0-6">{icon} <strong class="ml-0-4">{label} {name}</strong></p>',
      },
      filters: {
        type: {
          Accessoires: 'Accessoires',
          Chaussures: 'Chaussures',
          Chemises: 'Chemises',
          Costumes: 'Costumes',
          'Manteaux et Vestes': 'Manteaux et Vestes',
          'Pantalons et Shorts': 'Pantalons et Shorts',
          'Pulls et Sweats': 'Pulls et Sweats',
          'Sous-vêtements et Maillots de bain':
            'Sous-vêtements et Maillots de bain',
          'T-shirts et Polos': 'T-shirts et Polos',
          Jupes: 'Jupes',
          Robes: 'Robes',
        },
      },
      color: {
        leaving_soon: {
          title: 'Sur le départ.',
          desc: '{left} pour précommander {product} en {colour}. Passé ce delai, cette couleur ne sera plus disponible en précommande.',
          days_left: 'Dernier jour | Plus que 1 jour | Plus que {count} jours',
          some_days: 'Plus que quelques jours',
          ended: 'La précommande de la couleur est terminée.',
        },
        new: {
          title: 'Nouvelle couleur',
          desc: 'Tout juste sortie.',
        },
      },
      testimonials: {
        title: 'Avis et notes de la communauté',
        number: 'Note globale basée sur <strong>{number} avis</strong>',
        text: 'Ces avis sont collectés auprès de clientes ayant acheté une version précédente du produit.',
      },
      traca: {
        title: 'Traçabilité',
        know_all: 'Tout savoir sur la traçabilité de ce produit.',
      },
    },
    purchase: {
      price: {
        preco: 'En précommande',
        stock: 'En stock',
      },
      timer: {
        before: '',
        available_in: 'Disponible dans',
        over: 'Précommande terminée',
        soon: 'quelques instants',
        only: 'Plus que',
        left: '',
      },
      estimatedDelivery: 'Livraison estimée',
      estimated_delivery_small: 'Livraison :',
      delivery: 'Livraison',
      batchEnd: 'pour être livré entre<br />le {first} et le {last} {month}',
      precoEnd: 'avant la fin de la précommande',
      stockEnd: 'avant la fin de la vente',
      precoEndTooltip:
        'Les premières précommandes sont les premières livrées. En ce moment, la précommande en cours sera livrée chez vous entre le {current_first} et le {current_last} {current_month}. La prochaine précommande sera livrée du {next_first} au {next_last} {next_month}.',
      nextPrecoDelivery: 'avant la prochaine période de livraison :',
      already: 'Déjà',
      preco: 'précommandes',
      nbPreco: 'pièces précommandées',
      inStock: 'pièces en stock',
      'size-guide': 'Guide des tailles',
      exchange: 'Livraison & retours',
      between: 'entre le {first} et le {last} {month}',
      between_small: '{first} - {last} {month}',
      fromTo: 'du {first} au {last} {month}',
      fewDays: 'en quelques jours.',
      noDays: 'Date non renseignée pour le moment.',
      contactCare:
        "Pour plus d'informations, veuillez contacter notre service client.",
      beforeChristmas: 'Avant Noël',
      stock_preco_why: 'Comment ça fonctionne ?',
      label: {
        jacket: 'Veste :',
        pant: 'Pantalon :',
      },
      no: {
        jacket: 'Pas de veste',
        pant: 'Pas de pantalon',
      },
      errors: {
        size: {
          empty: 'Veuillez sélectionner une taille',
        },
        addToCart: {
          fail: 'Un problème technique est survenu... Veuillez réesayez plus tard. <a href="https://help.asphalte.com/fr-FR" target="_blank">Vous pouvez contacter notre service client</a> pour toute demande particulière.',
        },
      },
      modal: {
        delivery: 'Livraison et retours',
        size: 'Guide des tailles',
      },
    },
    orders: {
      error: {
        loading:
          'Houston, on a un problème. La mission de chargement de vos commandes a échoué pour une raison inconnue. Si le problème persiste après actualisation de la page, n’hésitez pas à contacter notre service client. Reçu ?',
      },
      title: 'Mes commandes',
      almost_there: 'Ça arrive ! Bientôt réunis',
      filters: {
        label: 'Mes dernières commandes :',
        in_progress: 'En ce moment',
        returns: 'Échangées',
        year: '{year}',
      },
      no_order: 'Aucune commande pour le moment.',
    },
    order: {
      number: 'Commande n°',
      number_param: 'Commande n°{number}',
      number_full: 'Numéro de commande :',
      created_at: 'passée le',
      channel: {
        label: 'Canal de vente :',
        online: 'En ligne',
        retail: 'En magasin',
      },
      delivery_at: 'Livraison à',
      go_to: 'Qu’est-ce qu’on a là-dedans ?',
      detail: 'Détail de la commande',
      print: 'Imprimer la facture',
      shipping: 'Mode de livraison',
      shipping_address: 'Adresse de livraison',
      billing_address: 'Adresse de facturation',
      update_address: {
        title: 'Modification de l’adresse de livraison',
        edit: 'Mettre à jour mon adresse',
        label: 'Informations :',
        info: 'Nous vous contacterons par mail quelques jours avant la livraison au cas ou vous devriez changer au dernier moment.',
        pickup_point_update:
          'Vous préférez récupérer votre commande en point relais ?',
        change_to_pickup_point: 'Je choisi la livraison en point relais',
        update_pickup_point: 'Mettre à jour le point relais',
        choice: 'Choix du mode de livraison',
        choose_home_delivery: 'Je souhaite me faire livrer à domicile',
        lock_country_reason:
          "Vous ne pouvez pas changer le pays de livraison associé à la commande initiale. Si c'est une demande spécifique, merci de contacter notre service client.",
        delivery: {
          domicile: 'Livraison à domicile',
          relais: 'Livraison en point relais',
          new_address: 'Ajouter une nouvelle adresse',
          save_for_later: "Ajouter cette adresse à ma liste d'adresses",
          hide_all_addresses: 'Masquer toutes les adresses enregistrées',
          show_all_addresses: 'Afficher toutes les adresses enregistrées',
          save: "Mettre à jour l'adresse de livraison",
          error_no_address: 'Veuillez sélectionner une adresse de livraison',
        },
        pickup_point: {
          search_label:
            'Autour de quelle zone souhaitez-vous rechercher un point relais ?',
          search: 'Afficher les point relais autour de cette adresse',
        },
        error: {
          default:
            "Une erreur est survenue lors de la mise à jour de l’adresse de livraison. Si le problème persiste, n'hésites pas à contacter notre service client.",
          cannot_change_shipping_country:
            "Vous ne pouvez pas changer le pays de livraison associé à la commande initiale. Si c'est une demande spécifique, merci de contacter notre service client.",
        },
      },
      home_delivery: 'Livraison à domicile',
      relay_point_delivery: 'Livraison en point relais',
      see_map: 'Voir sur la carte',
      email: 'Adresse email',
      paymentMode: 'Mode de paiement',
      phone: 'Téléphone',
      follow: 'Suivre mon colis',
      delivered_by: 'Suivez le facteur de {trackingCompany}',
      fullfilment_number: 'Numéro de colis :',
      inside_box: 'Ce que votre colis a dans le ventre',
      canceledAt: 'Commande annulé le {date}',
      refunded: 'Total remboursé',
      cancel_reason: {
        CUSTOMER: 'Commande annulée suite à une demande utilisateur',
        DECLINED: "Commande annulée à cause d'un refus de paiement",
        FRAUD: 'Commande annulée suite à une suspition de fraude',
        INVENTORY: 'Commande annulée suite à soucis de stock',
      },
      delivered_before: 'Livré au plus tard le {date}',
      delivery: 'Livraison estimée',
      initial_delivery: 'Livraison estimée initiale : ',
      new_delivery: 'Nouvelle livraison estimée : ',
      careGuide: "Guide d'entretien",
      retoucheurs: 'Faire une retouche',
      line: {
        'in-some-days': 'Livraison prévue : dans quelques jours',
        deleted: 'Le produit a été retiré de la commande',
      },
      returns: {
        title: 'Retours',
        'how-to': "Tout ce qu'il faut savoir sur les retours",
        explains:
          'Si un article ne vous donne pas entière satisfaction, ou n’est pas à votre taille, vous pouvez le retourner en cliquant sur le bouton ci-dessous :',
      },
      recap: 'Récapitulatif de la commande',
      subtotal: 'Sous total :',
      discount: {
        items: 'Réduction sur les produits',
        shipping: 'Réduction sur les frais de port',
      },
      'shipping-price': 'Frais de port',
      total: 'Total payé',
      exchange: 'Échangé après retour',
      inside: 'Dans ma commande',
      items: '{number} produit | {number} produits',
      shippingStatus: {
        DELIVERED: 'Livré',
        PACKED: 'Prêt à être expédié',
        SHIPPED: 'En livraison',
        PREPARATION: 'Colis en cours de préparation',
        SCHEDULED: 'Bientôt entre nos mains',
        RAW: 'En cours',
      },
      status: {
        label: 'Statut',
        label_pt: 'Statut :',
        RAW: 'En cours',
        CANCELED: 'Annulée',
        CANCELLED: 'Annulée',
        AUTHORIZED: 'Autorisée',
        PAID: 'Payée',
        PARTIALLY_PAID: 'Partiellement payée',
        PARTIALLY_REFUNDED: 'Partiellement remboursée',
        PARTLY_DELIVERED: 'Partiellement livrée',
        PENDING: 'En attente de paiement',
        REFUNDED: 'Remboursée',
        DELIVERED: 'Livrée',
        IN_TRANSIT: 'En livraison',
        EXCHANGE: 'Échangée',
        VOIDED: '',
      },
      line_item: {
        CANCELED: 'Annulé',
      },
      timeline: {
        created: 'Commande reçue 5/5',
        packed: "Emballé c'est pesé ! Paquet expédié.",
        in_transit: 'Un peu de patience, ça arrive',
        delivered: 'Vous voilà enfin réunis',
      },
      pickup_point: {
        opening_hours: "Horaires d'ouverture",
        opening_days: 'Ouvert le <strong>{days}</strong>',
        all_days: 'Ouvert <strong>tous les jours</strong>',
        closed: 'Fermé',
        open: {
          during_lunch: 'Entre midi et deux',
          after_7: 'Après 19h',
        },
        days: {
          0: 'Lundi',
          1: 'Mardi',
          2: 'Mercredi',
          3: 'Jeudi',
          4: 'Vendredi',
          5: 'Samedi',
          6: 'Dimanche',
        },
        show_hours: "Consulter les horaires d'ouverture",
        hide_hours: 'Masquer les horaires d’ouverture',
      },
      scheduled: {
        title: 'Dernières heures pour caler la livraison de votre colis',
        subtitle:
          'Vous pouvez modifier votre adresse de livraison jusqu’à minuit.',
      },
      reschedule: {
        title:
          'Pour ajuster la date de livraison par rapport à votre emploi du temps, ça se passe ici.',
        done: 'C’est noté ! Votre livraison a bien été replanifiée.',
        form_label:
          'Merci de nous indiquer la date à laquelle vous souhaiteriez recevoir votre paquet :',
        cta: 'Je choisis ma date de livraison',
        cta_label: 'Nouvelle date de livraison souhaitée',
        submit: 'C’est mon dernier mot',
        success: 'Livraison reprogrammée avec succès',
        error: 'Erreur lors de la reprogrammation de la livraison',
      },
      error: {
        shipping_loading:
          "Il y a eu une erreur au chargement de votre adresse de livraison. Si le problème persiste après avoir rechargé votre page, n'hésitez pas à contacter notre service client.",
      },
    },
    sponsorship: {
      title: 'Ma tirelire',
      intro: `
        <p>Parlons peu, parlons sous. Mais non, ce n’est pas tabou !</p>
        <p>Dans cette rubrique, vous retrouverez votre cagnotte Asphalte et les deniers accumulés grâce à notre système de parrainage.</p>
        <p>
          Pour les nouveaux, on vous rappelle la mécanique : à chaque fois que vous partagez votre code parrain à quelqu’un, 
          <strong>le quelqu’un en question économise {parrainagefilleulprice} €</strong> sur sa première commande et <strong>on crédite votre tirelire de {parrainageprice} €.</strong>
          Comme ça, tout le monde est content. Ce code, le voici :
        </p>
        `,
      code: 'Mon code de parrainage :',
      messageToShare: 'Exemple de message à partager :',
      message:
        'Asphalte, ça te dit quelque chose ? C’est une marque française qui propose en précommande des classiques durables fabriqués en Europe. Si ça t’intéresse, tu peux profiter d’une ristourne de {parrainageprice}€ sur ta première commande, histoire de tester leurs produits. Pour ça, il te suffit d’entrer ce code au moment du paiement : <strong>{code}</strong>. Leur site est juste là : <a href="{link}"><u>{link}</u></a>',
      cheat: {
        title: 'Avis aux petits malins :',
        text: `Ce système de parrainage fonctionne sur un modèle gagnant-gagnant, alors soyez beaux joueurs. N’allez pas essayer de créer 37 comptes dans l’espoir de vous auto-parrainer, on s’en rendra compte rapidement. En plus, c’est un motif d’exclusion inscrit dans la rubrique "Parrainage" de nos Conditions Générales de Ventes, et ça nous ferait mal d’avoir à supprimer votre compte pour un truc pareil. Entre nous, vous passerez plus de temps à essayer de contourner le système qu'à envoyer votre code à trois copains, alors autant jouer selon les règles.`,
      },

      cagnotte: {
        title: 'Ma Cagnotte',
        explain:
          'Si vous décidez de craquer le PEL et de dépenser votre butin, cliquez sur votre code cagnotte là-dessous pour le copier puis collez-le dans « Code Promo » avant de finaliser votre commande.',
        'you-have': 'Vous disposez de',
        code: 'Mon code cagnotte :',
      },

      faq: {
        line1: {
          title: 'Qui peut parrainer un ami ?',
          content:
            'Il n’y a que les clients ayant déjà passé une commande et ayant un compte qui peuvent parrainer d’autres personnes. Les vrais, quoi.',
        },
        line2: {
          title: 'Qui peut-on parrainer ?',
          content:
            'Tous ceux qui n’ont encore jamais commandé sur notre site. Par contre on aime pas trop les codes de parrainage qui finissent sur Google ou Facebook, comme écrit dans nos Conditions Générales de Ventes, c’est pour votre sphère privée : vos potes et potes de potes quoi.',
        },
        line3: {
          title: 'Tous les frais de livraison sont-ils offerts ?',
          content:
            "Vos amis peuvent bénéficier des frais de livraison offerts à condition qu'ils ne dépassent pas 9€.",
        },
        line4: {
          title: 'Comment parrainer un ami ?',
          content:
            'C’est simple comme bonjour. Il suffit de partager votre code de parrainage avec vos potes. Vos amis devront ensuite appliquer ce code à leur panier lors de leur commande sur notre site. Le minimum d’achat pour utiliser le code est de 50€.',
        },
        line5: {
          title: 'Est-il possible de parrainer plusieurs personnes ?',
          content:
            'Oui ! Vous pouvez cumuler ces parrainages sur votre cagnotte. Donc si la question est : est-ce que je peux me faire payer mes fringues Asphalte avec la contribution de mes potes ? C’est oui !',
        },
        line6: {
          title: 'Existe-t-il une limite de filleul à parrainer ?',
          content: 'Oui, vous ne pouvez pas parrainer plus de 25 filleuls.',
        },
        line7: {
          title:
            'Quand seront crédités les {parrainageprice}€ sur mon compte ?',
          content:
            'Instantanément après la première commande de votre filleul. C’est immédiat, et on vous envoie même un mail pour vous en informer.',
        },
      },
      requirements:
        'Vous devez passer une commande pour activer votre code parrain',
    },
    people: {
      verified: 'Acheteur vérifié',
    },
    testimonial: {
      action: {
        show: 'Voir les avis',
        hide: 'Cacher les avis',
      },
      see: 'Voir les {number} avis',
      based_on_number: 'sur la base de {number} avis',
      size: 'Taille :',
      color: 'Couleur :',
      number: '{number} avis',
      'based-on': 'Note globale basée sur',
      'no-comment': 'Pas de commentaire',
      empty: 'Aucun avis client associé à ce ou ces filtres',
      loading: 'Chargement des avis clients',
      show_answer: 'Afficher 1 réponse',
      explain_note:
        'C’est la note moyenne donnée par plus de {number} clients. Leur exigence ? Elle est à la hauteur de cette note.',
      filter: {
        by: 'Filtrer par :',
        color: 'Couleur',
        size: 'Taille',
        note: 'Note',
      },
    },
    impact: {
      unit: {
        Carbone: 'kg',
        Eau: 'L',
        Energie: 'MJ',
        Phosphate: 'g',
      },
      conso: {
        Carbone: 'de CO2 produits',
        Eau: "d'eau consommés",
        Energie: "d'énergie consommés",
        Phosphate: 'de phosphore produit',
      },
      detail: {
        Carbone:
          'D’après l’Agence Européenne pour l’Environnement, novembre 2020.',
        Eau: 'Calculs effectués sur la base de la moyenne nationale, Véolia.',
        Energie: 'D’après Engie, janvier 2020.',
        Phosphate: 'D’après AgriBalyse, https://agribalyse.ademe.fr/',
      },
    },
    input: {
      empty: 'Le champs est requis',
      optional: 'Optionnel',
      gender: {
        homme: 'M.',
        femme: 'Mme.',
        undefined: 'Non binaire',
      },
      email: {
        label: 'Email',
        placeholder: 'Votre email ici',
        wrong: 'Vous devez renseigner un email',
      },
      date: {
        minDate: 'La date est inférieure à la date minimale',
        maxDate: 'La date est supérieure à la date maximale',
      },
      error: {
        UNIDENTIFIED_CUSTOMER: 'Mot de passe incorrect',
        BAD_DOMAIN: '',
        BLANK: '',
        CONTAINS_HTML_TAGS: '',
        CONTAINS_URL: '',
        CUSTOMER_DISABLED: '',
        INVALID: '',
        INVALID_MULTIPASS_REQUEST: '',
        NOT_FOUND: '',
        PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE: '',
        TAKEN: '',
        TOKEN_INVALID: '',
        TOO_LONG: '',
        TOO_SHORT: '',
        ALREADY_ENABLED: 'Votre compte est déjà activé',
        PHONE: 'Le numéro de téléphone est invalide',
        passwordLength: 'Le mot de passe doit contenir au moins 6 caractères',
        password_match: 'Les mots de passe ne correspondent pas',
        invalid_password: 'Le mot de passe est incorrect',
        sexe: 'Veuillez sélectionner un choix',
        firstName: 'Prénom invalide',
        lastName: 'Nom invalide',
      },
    },
    account: {
      hello: 'Bien le bonjour',
      welcome:
        'Les bons comptes (client) font <span class="text-color-secondary">les bons amis</span>',
      enjoy: {
        default:
          'Les roses sont rouges, les violettes sont bleues, chez Asphalte on vous aide à shopper moins mais mieux.',
        birthday:
          'Joyeux anniversaire {name}, joyeux anniversaire ! (À l’écrit, on chante moins faux)',
        morning: 'Et bon matin, comme disent nos copains québécois.',
        day: 'Depuis Bordeaux, toute l’équipe vous souhaite une belle journée ! Amour et cannelés.',
        evening: 'Bonsoir, Ami, bonsoir !',
        new_year:
          'Faute de pouvoir s’embrasser sous le gui, on vous souhaite bonne année ici !',
        first_order_birthday:
          'C’est l’anniversaire de votre première commande. Une bougie de plus à souffler ensemble !',
      },
      label: 'Mon compte',
      labels: {
        email: 'Email',
        password: 'Mot de passe',
        birthday: 'Date de naissance',
        gender: 'Genre',
        firstname: 'Prénom',
        lastname: 'Nom',
        phone: 'Téléphone',
        current_password: 'Mot de passe actuel',
        new_password: 'Nouveau mot de passe',
        new_password_confirmation: 'Confirmation du nouveau mot de passe',
      },
      nav: {
        home: 'Accueil',
        orders: 'Mes commandes',
        profile: 'Mon compte',
        address: 'Mes adresses',
        parrainage: 'Ma tirelire Asphalte',
        alerts: 'Mes notifications',
        logout: 'Se déconnecter',
      },
      menu: {
        orders: {
          preTitle: 'Mes',
          title: 'commandes',
          description:
            'Pour vous faciliter la vie, on a réuni ici ce qui concerne vos précédents achats (commandes, factures, SAV).',
        },
        profile: {
          preTitle: 'Mon',
          title: 'Compte',
          description:
            ' Ici, vous pouvez modifier votre numéro, votre mot de passe, votre mail et même votre prénom (perso, on le trouve très beau).',
        },
        address: {
          preTitle: 'Mes',
          title: 'Adresses',
          description:
            'Précisez ici vos adresses et préférences de livraison. Ça nous aidera à viser la bonne porte pour ne pas livrer le voisin.',
        },
        alerts: {
          preTitle: 'Mes',
          title: 'Notifications',
          description:
            'Dans cette rubrique, gérez vos notifications et choisissez vos sujets préférés.',
        },
        parrainage: {
          preTitle: 'Ma',
          title: 'Tirelire Asphalte',
          description: 'Programme de parrainage et code cagnotte.',
        },
        care_guides: {
          preTitle: 'Les',
          title: 'Guides d’entretien',
          description:
            'Tous nos conseils pour prendre soin de vos vêtements et chaussures.',
        },
      },
      address: {
        default: 'Votre adresse par défaut',
        is_default: 'Par défaut',
        list: 'Toutes vos adresses',
        create: 'Nouvelle adresse',
        edit: 'Modifier une adresse',
        firstName: 'Prénom',
        lastName: 'Nom',
        companyName: 'Entreprise',
        address1: 'Adresse',
        address2: 'Complément d’adresse',
        city: 'Ville',
        postalCode: 'Code postal',
        country: 'Pays',
        province: 'Province',
        state: 'État',
        select_province: 'Sélectionner une province',
        select_state: 'Sélectionner un état',
        phone: 'Téléphone',
        phone_explain:
          'Pour permettre à notre prestataire de livraison de vous contacter en cas de problème.',
        error:
          'Une erreur est survenue, si le problème persiste, veuillez contacter le service client.',
        error_taken: 'Cette adresse est déjà enregistrée',
        no_address: 'Aucune adresse enregistrée pour le moment.',
      },
      profile: {
        informations: 'Mes informations',
        password: 'Mon mot de passe',
        no_mail:
          "Vous ne pouvez pas modifier votre email pour le moment, la fonctionnalité n'est pas encore opérationnelle de notre côté. Si vous avez besoin de mettre à jour votre email, n'hésitez pas à contacter le service client.",
      },
      title: "S'identifier",
      p1: 'Pour accéder à votre compte ou en créer un si ce n’est pas encore fait, il suffit de rentrer votre email ici.',
      placeholder: {
        email: 'example@email.com',
      },
      error: {
        email: 'Email invalide',
      },
      nextButton: "Je m'identifie",
      activationLinkSent:
        'Un email vous a été envoyé, cliquez sur « Activer mon compte » pour terminer votre inscription et suivre votre commande.',
      wait: "Cela peu prendre un peu de temps... Si d'ici une dizaine de minute vous n'avez pas reçu d'email, vous pouvez retenter le coup.",
    },
    password: {
      security: {
        advice:
          'Nous vous conseillons de choisir un mot de passe sécurisé qui respecte les critères suivants&nbsp;:',
        length: 'Contient 8 caractères minimum',
        uppercase: 'Contient au moins une majuscule',
        lowercase: 'Contient au moins une minuscule',
        number: 'Contient au moins un chiffre',
        special: 'Contient au moins un caractère spécial',
        label: 'Sécurité :',
        weak: 'Faible',
        medium: 'Moyenne',
        strong: 'Forte',
      },
    },
    register: {
      title: "S'inscrire",
      p: 'On nous dit dans l’oreillette que vous n’avez pas de compte. Mais on va remédier à ça. C’est simple, vous devriez trouver les réponses à toutes nos questions sans trop de problème.',
      placeholder: {
        firstName: 'Juste',
        lastName: 'LeBlanc',
      },
      error: {
        unexpectedError:
          'Une erreur est survenue, veuillez contacter le service client',
      },
      password: 'Créer mon mot de passe',
      changeEmail: 'Modifier mon email',
      nextButton: 'Suivant',
      sendButton: "Je m'inscris",
      sexe: 'Sexe',
      men: 'Homme',
      women: 'Femme',
      firstName: 'Prénom',
      lastName: 'Nom',
      date: 'Date de naissance',
      news: 'Abonnement',
      newsText:
        'J’aimerais qu’on me tienne au courant (questionnaires, lancements, etc.) mais pas qu’on me spamme 5 jours par semaine, merci !',
    },
    activate: {
      title: 'Activer mon compte',
      p: 'Vous avez déjà commandé sur notre site, mais vous n’avez pas encore activé votre compte. Pour ça, il nous manque encore quelques infos. Ça ne prendra que 2 minutes.',
      sendButton: "J'active mon compte",
    },
    login: {
      title: 'Se connecter',
      p: 'Ça fait du bien de vous revoir dans les parages. On vous laisse entrer votre mot de passe et on se retrouve juste après.',
      placeholder: {
        password: '6 caractères minimum',
      },
      password: 'Mot de passe',
      forgotPasswordLink: 'Mot de passe oublié ?',
      codeSent: 'Email envoyé',
      forgotPasswordLinkSent:
        'Un e-mail de réinitialisation de mot de passe a été envoyé à votre adresse de contact.',
      sendButton: 'Je me connecte',
      rememberMe: 'Se souvenir de moi',
    },
    reset_password: {
      title: 'Réinitialiser mon mot de passe',
      desc: 'Pas de galère ! Entrez un nouveau mot de passe pour votre compte',
    },
    request: {
      failed: 'La requête à échouée',
      'no-result': 'Aucun résultat',
    },
    blog: {
      news: {
        noPost: "Il n'y a pas d'article pour le moment.",
      },
      'guides-dentretien': {
        noPost: "Il n'y a pas de guide d'entretien pour le moment.",
      },
    },
    error: {
      happend:
        'Houston, on a un problème. La mission a échoué pour une raison inconnue. Si le problème persiste après actualisation de la page, n’hésitez pas à contacter notre service client. Reçu ?',
      default: {
        title: 'Il y a eu une erreur.',
        text: "Cette page n'est pas disponible.",
        backToHome: "Retourner à la page d'accueil",
      },
      reset_password: {
        INVALID:
          "Houston, on a un problème. Le lien n'est plus valide... Veuillez recommencer la procedure depuis le départ. Si le problème persiste après plusieurs essais, n’hésitez pas à contacter notre service client. Reçu ?",
        PASSWORD_STARTS_OR_ENDS_WITH_WHITESPACE:
          'Houston, on a un problème. Le mot de passe ne peut pas commencer ou finir par un espace.',
        TOO_LONG: 'Houston, on a un problème. Le mot de passe est trop long.',
        TOO_SHORT: 'Houston, on a un problème. Le mot de passe est trop court.',
      },
      404: {
        title: '404 - Page non trouvée.',
      },
    },
    search: {
      type: {
        agenda: 'Agenda :',
        eshop: 'Eshop :',
        stock: 'Stock :',
      },

      label: {
        article: 'Vous chercher un article ?',
        care_guide: 'Vous cherchez un guide d’entretien ?',
      },

      no_result: 'Aucun résultat pour votre recherche.',
      results: '{number} résultat | {number} résultat | {number} résultats',
      'number-of':
        '{number} produit affiché | {number} produit affiché | {number} produits affichés',
      display: {
        title: 'Affichage',
        cols: '1 colonne | {number} colonnes',
        pageSize: {
          title: 'Nombre de produits par page',
        },
        listDisplay: {
          title: 'Affichage de la liste',
          list: 'Liste',
          grid: 'Grille',
        },
      },

      filter: {
        loading: 'Chargement en cours',
        reset: 'Réinitialiser les filtres',
        all_reset: 'Réinitialiser tous les filtres',
        selected: '{number} éléments sélectionnés',
        title: 'Filtres',
        wait_for_category: 'Sélectionner une catégorie pour filtrer par taille',
        category: {
          title: 'Catégorie',
          all: 'Toutes',
        },
        size: {
          title: 'Taille',
          all: 'Toutes',
        },
        price: {
          title: 'Prix',
          all: 'Tous',
        },
      },
      categories: {
        't-shirt': 'T-shirts',
        pulls: 'Pulls',
        'pants-shorts': 'Pantalon & Shorts',
        chemises: 'Chemises',
        'manteaux-vestes': 'Manteaux & Vestes',
        chaussures: 'Chaussures',
        costumes: 'Costumes',
        accessoires: 'Accessoires',
        maillots: 'Sous-vêtements & Maillots de bain',
      },
    },
    teasing: {
      dates: '',
      subscribe: 'Il faut <strong>s’inscrire</strong> pour tout voir.',
      slice: {
        title: 'C’EST QUOI LA SUITE ?',
        dates: '',
        // 'Pour l’instant, on peut juste vous dire que notre produit sortira <strong>le {date} prochain</strong>. Et aussi qu’il sera stylé.',
        subscribe: 'Il faut <strong>s’inscrire</strong> pour tout voir.',
      },
      story: {
        title_1: 'Chez vous aussi l’image est floue ?',
        title_2: 'Bien essayé, mais non.',
        title_3: 'Toujours pas.',
        title_4: 'Niet',
        title_5: 'Ça suffit oui ?',
        title_6: 'Vous êtes encore là, vous ?',
        title_7: 'On va appeler la police, on vous prévient...',
        title_8: 'Bon. Là. On ne peut plus rien pour vous !',
        title_inf: 'Bon. Là. On ne peut plus rien pour vous !',
      },
    },
    'co-creation': {
      title: 'Co-création',
    },
    notification: {
      text: 'Et si on vous tenait au courant de nos prochaines sorties ?',
      positive: 'Dîtes-moi tout !',
      negative: 'Non, ça ira.',
    },
    questionnaire: {
      new: 'Nouveau !',
      available: 'Disponible',
      type: {
        'plan-de-collection': 'Questionnaire plan de collection',
        development: 'Questionnaire développement',
        'achat-matiere': 'Questionnaire coloris',
        satisfaction: 'Questionnaire satisfaction',
        brand: 'Questionnaire brand',
        'autres-sujets': 'Autres sujets',
      },
    },
    collection: {
      unlock: {
        error:
          'Bien tenté… mais le mot de passe est incorrect. Essayez à nouveau !',
        done: {
          title: 'Code bon. Bienvenue chez vous !',
          text: "Les pièces étant en quantités très limitées, il n'y aura pas d'échanges sur cette vente, seulement des remboursements. Profitez !",
        },
        input_password: {
          label: 'Entrez le mot de passe pour accéder à la vente',
        },
        action: 'Gooooo',
      },
    },
    banner: {
      app: {
        title: 'Téléchargez l’app Asphalte.',
        text: 'Et rentrez avec nous dans l’an 2000.',
      },
    },
    preorder: {
      explain: {
        title: 'Ça marche comment la précommande ?',
        text_1:
          'Concrètement, ça signifie que vous achetez le vêtement avant qu’il ne soit produit. En précommandant, c’est vous qui lancez la production.',
        text_2:
          'Avec ce système, on ne produit que ce qu’on vend, donc on évite la surproduction, et ça nous permet de vous offrir un excellent rapport qualité prix.',
        text_3: 'En détail, ça ressemble à ça :',
        step_1: {
          title: '1. Questionnaire',
          text: 'Vous participez à la création des vêtements qui vous font de l’œil.',
        },
        step_2: {
          title: '2. Prototype',
          text: 'On file chez les meilleurs fabricants avec vos réponses et on planche sur la production d’un prototype à la hauteur.',
        },
        step_3: {
          title: '3. Precommande',
          text: 'Une fois le prototype calibré au millimètre on lance la phase de précommande pour une durée limitée.',
        },
        step_4: {
          title: '4. Fabrication',
          text: "Vos commandes sont transmises à l'usine qui charbonne pour tenir les délais. Vous êtes tenus informés, étape par étape.",
        },
        step_5: {
          title: '5. Livraison',
          text: "On vous livre où vous l'avez demandé vos produits qui sortent de l’usine.",
        },
        step_6: {
          title: '6. Stock',
          text: 'On produit quelques pièces en plus pour les échanges. Et on met le reste en stock pour ceux qui sont passés à côté de la précommande.',
        },
      },
    },
  })
}
